import {
  OrganizationTypeEnumType,
  UserRoleEnumType,
} from '~/common/types/graphql'
import { window } from '~/utils/browser'

import { SessionUser, WindowUser } from 'shared/utils/auth/types.d'

/**
 * @deprecated
 *
 * Sets the current user onto window context for easy reference
 * during debugging. We should avoid using this for real application
 * state management as we have better options now
 */
export const setUser = async (user: SessionUser): Promise<void> => {
  if (!window) return

  window.gcx = window.gcx || {}
  window.gcx.currentUser = {
    id: user?.id || '',
    firstName: user?.firstName || '',
    lastName: user?.lastName || '',
    email: user?.email || '',
    role: user?.role || UserRoleEnumType.Contributor,
    organization: {
      id: user?.organization?.id || '',
      name: user?.organization?.name || '',
      domain: user?.organization?.domain || '',
      type: user?.organization?.type || OrganizationTypeEnumType.Basic,
    },
  }
}

/**
 * Deprecated
 *
 * returns whatever context has been stored on `window`. You
 * should instead pull the current user from session
 */
export const getWindowUser = (): WindowUser | undefined => {
  return window?.gcx?.currentUser
}
